import EditReviewCyclePage from "./EditReviewCycle";

export default EditReviewCyclePage;
